// extracted by mini-css-extract-plugin
module.exports = {"externalContainer":"Login_externalContainer__3_te0","form":"Login_form__1Gwp5","label":"Login_label__a2OAI"};